import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';

import { createCardToken } from 'actions/BookingActions';
import { compose } from 'redux';
import { getTotalDeposit } from 'selectors/services';

import { Payment as PaymentInformation } from 'components/BookingSteps/Payment/Payment';

import AppointmentInfo from 'routes/book/AppointmentInfo';

class Payment extends React.Component {
  handleSubmit = ({ cardElement, stripe }) => {
    const { isLoading, clientName } = this.props;

    if (isLoading) {
      return false;
    }

    return this.props.createCardToken({
      stripe,
      cardElement,
      clientName,
      submitBookingOnSuccess: true,
    });
  };

  render() {
    const { isLoading, servicesDeposits, paymentErrorMessage } = this.props;

    return (
      <>
        <PaymentInformation
          isLoading={isLoading}
          clientName={this.props.clientName}
          onSubmit={this.handleSubmit}
          paymentErrorMessage={paymentErrorMessage}
          servicesDeposits={servicesDeposits}
        />
        <AppointmentInfo />
      </>
    );
  }
}

const PaymentForm = compose(
  withRouter,
  connect(
    (state) => ({
      clientName: `${state.appointment?.firstName} ${state.appointment?.lastName}`,
      isLoading: state.appointment?.loading,
      paymentErrorMessage: state.appointment?.error?.error,
      servicesDeposits: getTotalDeposit(state),
    }),
    (dispatch, ownProps) => ({
      createCardToken(data) {
        dispatch(
          createCardToken(data, function navigateToNextStep({ stepKey }) {
            ownProps.navigateToNextStep({ stepKey });
          }),
        );
      },
    }),
  ),
)(Payment);

export default PaymentForm;
